import { ratingClasses } from "@mui/material";
import "react/jsx-runtime";
import { typography } from "../../../../../themes/typography/typography.js";
import "color-alpha";
import "../../../../../themes/external-theme/external-theme.js";
import "../../../../../themes/pickers-popper/pickers-popper.js";
import "../../../../../themes/shadows/shadows.js";
import "../../../../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../../../../themes/typography/utils/typographyVariants/typographyVariants.js";
import "../../../../../constants/breakpoints/breakpoints.js";
import "../../../../../constants/create-theme/create-theme.js";
import "@mui/material/styles";
import "../../../../../constants/colors/palette.js";
import "../../../../../themes/alert/alert.js";
import "../../../../../themes/alert/components/ErrorIcon/ErrorIcon.js";
import "@mui/material/SvgIcon/index.js";
import "../../../../../themes/alert/components/InfoIcon/InfoIcon.js";
import "../../../../../themes/alert/components/SuccessIcon/SuccessIcon.js";
import "../../../../../themes/alert/components/WarningIcon/WarningIcon.js";
import "../../../../../themes/button/button.js";
import "../../../../../themes/button/styles/external/bordered.styles.js";
import "../../../../../themes/button/styles/external/filled.styles.js";
import "../../../../../themes/button/styles/internal/bordered.styles.js";
import "../../../../../themes/button/styles/internal/borderless.styles.js";
import "../../../../../themes/button/styles/internal/filled.styles.js";
import "../../../../../themes/button/styles/internal/shadowed.styles.js";
import "../../../../../themes/checkbox/checkbox.js";
import "../../../../../themes/checkbox/components/CheckedIcon/CheckedIcon.js";
import "../../../../../themes/checkbox/components/IndeterminateIcon/IndeterminateIcon.js";
import "../../../../../themes/form-control-label/form-control-label.js";
import "../../../../../themes/radio/radio.js";
import "../../../../../themes/switch/switch.js";
const rootStyles = {
  display: "flex",
  alignItems: "center"
};
const ratingStyles = {
  width: 16,
  height: 16,
  [`.${ratingClasses.icon}`]: {
    color: "grey.50"
  }
};
const scoreStyles = {
  ...typography["Lato Emphasized 1"],
  margin: "0 8px 0 4px"
};
const reviewsStyles = {
  ...typography["Lato Caption"],
  color: "grey.600"
};
export {
  ratingStyles,
  reviewsStyles,
  rootStyles,
  scoreStyles
};
